import { useSize } from 'ahooks';
import React, { useEffect, useState } from 'react';

/**
 * A hook to get the element's top position.
 *
 * @param elementRef - the ref object of the element from `React.useRef()`
 */
export const useElementTopPosition = (elementRef: React.MutableRefObject<HTMLDivElement | null>) => {
  const [elementTopPosition, setElementTopPosition] = useState<number | null>(null);
  const elementSize = useSize(elementRef);

  useEffect(() => {
    if (elementSize?.width) {
      // Update page navigation top if there is a change on page navigation width
      const elementOffsetTop = elementRef?.current?.offsetTop;
      if (elementOffsetTop !== undefined && elementSize?.width) {
        setElementTopPosition(elementOffsetTop);
      }
    }
  }, [elementSize?.width]);
  return elementTopPosition;
};
